import { render, staticRenderFns } from "./SecondaryHeaderTab.vue?vue&type=template&id=58b12f9a&scoped=true&"
import script from "./SecondaryHeaderTab.vue?vue&type=script&lang=ts&"
export * from "./SecondaryHeaderTab.vue?vue&type=script&lang=ts&"
import style0 from "./SecondaryHeaderTab.vue?vue&type=style&index=0&id=58b12f9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b12f9a",
  null
  
)

export default component.exports